import { ReactNodeViewRenderer, Node, mergeAttributes } from '@tiptap/react'
import { Component } from './component'

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		linkIcon: {
			setLinkIcon: () => ReturnType
		}
	}
}

export const LinkIcon = Node.create({
	name: 'linkIcon',

	isolating: true,

	defining: true,

	content: '',

	group: 'block',

	draggable: true,

	selectable: true,

	addAttributes() {
		return {
			link: {
				default: null,
				parseHTML: element => element.getAttribute('href'),
				renderHTML: attributes => {
					if (!attributes.link) {
						return {}
					}

					return {
						href: attributes.link,
					}
				},
			},

			icon: {
				default: icons.instagram,
				parseHTML: element => element.getAttribute('data-icon'),
				renderHTML: attributes => {
					if (!attributes.icon) {
						return {}
					}

					return {
						'data-icon': attributes.icon,
					}
				},
			},
		}
	},

	parseHTML() {
		return [
			{
				tag: 'a[data-type="linkIcon"]',
			},
		]
	},

	renderHTML({ HTMLAttributes, node }) {
		return [
			'a',
			mergeAttributes(HTMLAttributes, {
				'data-type': 'linkIcon',
			}),
			[
				'img',
				{
					src: node.attrs.icon,
					alt: '',
					style: 'width: 24px; height: 24px; border-radius: 0;',
				},
			],
		]
	},

	addCommands() {
		return {
			setLinkIcon:
				() =>
				({ commands }) =>
					commands.insertContent(`<a data-type="linkIcon"></a>`),
		}
	},

	addNodeView() {
		return ReactNodeViewRenderer(Component)
	},
})

export default LinkIcon

export const icons = {
	facebook: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/facebook.svg',
	instagram:
		'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/instagram.svg',
	twitter: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/x.svg',
	linkedin: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/linkedin.svg',
	youtube: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/youtube.svg',
	tiktok: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/tiktok.svg',
	pinterest:
		'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/pinterest.svg',
	snapchat: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/snapchat.svg',
	whatsapp: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/whatsapp.svg',
	reddit: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/reddit.svg',
	discord: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/discord.svg',
	github: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/github.svg',
	twitch: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/twitch.svg',
	telegram: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/telegram.svg',
	medium: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/medium.svg',
	quora: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/quora.svg',
	tumblr: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/tumblr.svg',
	flickr: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/flickr.svg',
	vimeo: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/vimeo.svg',
	spotify: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/spotify.svg',
	soundcloud:
		'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/soundcloud.svg',
	behance: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/behance.svg',
	dribbble: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/dribbble.svg',
	vk: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/vk.svg',
	weibo: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/sinaweibo.svg',
	line: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/line.svg',
	wechat: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/wechat.svg',
	skype: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/skype.svg',
	slack: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/slack.svg',
	mastodon: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/mastodon.svg',
	stackoverflow:
		'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/stackoverflow.svg',
	gitlab: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/gitlab.svg',
	bitbucket:
		'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/bitbucket.svg',
	codepen: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/codepen.svg',
	deviantart:
		'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/deviantart.svg',
	goodreads:
		'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/goodreads.svg',
	lastfm: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/lastdotfm.svg',
	meetup: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/meetup.svg',
	mixcloud: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/mixcloud.svg',
	periscope:
		'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/periscope.svg',
	producthunt:
		'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/producthunt.svg',
	slideshare:
		'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/slideshare.svg',
	tripadvisor:
		'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/tripadvisor.svg',
	vine: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/vine.svg',
	yelp: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/yelp.svg',
	foursquare:
		'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/foursquare.svg',
	xing: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/xing.svg',
	bandcamp: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/bandcamp.svg',
	patreon: 'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/patreon.svg',
	kickstarter:
		'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/kickstarter.svg',
	angellist:
		'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/angellist.svg',
	website:
		'https://cdn.jsdelivr.net/npm/simple-icons@v13/icons/internetexplorer.svg',
}
